// NavBar4 — Atlas "Nav menu" (Figma 12366:17362 desktop / 12366:17449 mobile).
// Single black bar: logo (left) + horizontal menu links + vertical divider +
// phone (pill w/ number on desktop, circle on mobile) + WhatsApp button.
// Mobile collapses the links into a hamburger drawer. Parent (nav_bar) config
// carries logo + colors + the phone/WhatsApp CTAs; children (menu_item) are the
// nav links with optional per-item icons (dropdowns).
//
// Reuses the shared nav_bar / menu_item tables (same columns as NavBar3),
// including the optional "Apply Now" pill built on NavBar3's cta3_* columns.
// The one addition of its own is `cta3_enabled_mobile` (migration
// 20260818130000): the Apply Now pill has separate desktop and mobile toggles,
// where `cta3_enabled` is the desktop half and this column the mobile half.

export const NAVBAR_2000_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    logo_icon: "",
    logo_icon_alt: "",
    logo_click_disabled: false,
    // Bar
    background_color: "#000000",
    nav_text_color: "#FFFFFF",
    active_menu_color: "#FFFFFF",
    border_color: "rgba(255,255,255,0.2)",
    divider_color: "",
    // Mobile drawer
    mobile_menu_text_color: "#FFFFFF",
    mobile_active_menu_color: "#FFFFFF",
    // Dropdown (nested items)
    dropdown_bg_color: "#222222",
    dropdown_text_color: "#FFFFFF",
    show_dropdown_icons: true,
    // CTA-1 (phone)
    cta1_enabled: true,
    cta1_icon: "",
    cta1_icon_alt: "Call",
    cta1_label: "+91 7973615772",
    cta1_href: "",
    cta1_bg_color: "rgba(0,0,0,0.1)",
    cta1_text_color: "#FFFFFF",
    cta1_border_color: "#FFFFFF",
    // CTA-2 (WhatsApp)
    cta2_enabled: true,
    cta2_icon: "",
    cta2_icon_alt: "WhatsApp",
    cta2_href: "",
    cta2_bg_color: "#4CAF51",
    cta2_text_color: "#FFFFFF",
    // CTA-3 (Apply Now — independent desktop / mobile visibility)
    cta3_enabled: false,
    cta3_enabled_mobile: false,
    cta3_label: "APPLY NOW",
    cta3_href: "",
    cta3_bg_color: "#D61229",
    cta3_text_color: "#FFFFFF",
    cta3_icon: "",
    cta3_icon_alt: "Apply Now",
    // Mobile chrome
    show_hamburger: true,
    hamburger_icon: "",
    hamburger_icon_alt: "",
    mobile_cancel_icon: "",
    mobile_cancel_icon_alt: "",
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    // --- Logo ---
    { fieldName: "logo_icon", label: "Logo", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload logo", required: true, defaultValue: "" },
    { fieldName: "logo_click_disabled", label: "Disable Logo Click", value: false, valueType: "boolean", filedType: "TOGGLE", placeholder: "Render the logo as a plain image", defaultValue: false, description: "Off by default, so the logo links to the home page. Turn ON to make the logo non-clickable \u2014 useful on standalone landing pages." },
    { fieldName: "logo_icon_alt", label: "Logo Alt Text", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter logo alt text", required: false, defaultValue: "" },

    // --- Bar colours ---
    { fieldName: "background_color", label: "Bar Background Color", value: "#000000", valueType: "string", filedType: "COLOR", placeholder: "#000000", required: false, defaultValue: "#000000" },
    { fieldName: "nav_text_color", label: "Menu Text Color (Desktop)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "active_menu_color", label: "Active Menu Color (Desktop)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "border_color", label: "Bar Border Color", value: "rgba(255,255,255,0.2)", valueType: "string", filedType: "COLOR", placeholder: "rgba(255,255,255,0.2)", required: false, defaultValue: "rgba(255,255,255,0.2)" },
    { fieldName: "divider_color", label: "Divider Color", value: "", valueType: "string", filedType: "COLOR", placeholder: "Defaults to the bar border colour", required: false, defaultValue: "" },
    { fieldName: "mobile_menu_text_color", label: "Menu Text Color (Mobile drawer)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "mobile_active_menu_color", label: "Active Menu Color (Mobile drawer)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- Dropdown (nested menu items) ---
    { fieldName: "show_dropdown_icons", label: "Show Dropdown Icons", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show icons on dropdown items", defaultValue: true },
    { fieldName: "dropdown_bg_color", label: "Dropdown BG Color", value: "#111111", valueType: "string", filedType: "COLOR", placeholder: "#111111", required: false, defaultValue: "#111111" },
    { fieldName: "dropdown_text_color", label: "Dropdown Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- CTA-1 (phone) ---
    { fieldName: "cta1_enabled", label: "Show Phone", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable phone", defaultValue: true },
    { fieldName: "cta1_icon", label: "Phone Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload phone icon (optional)", required: false, defaultValue: "" },
    { fieldName: "cta1_icon_alt", label: "Phone Icon Alt", value: "Call", valueType: "string", filedType: "INPUT", placeholder: "Call", required: false, defaultValue: "Call" },
    { fieldName: "cta1_label", label: "Phone Number", value: "", valueType: "string", filedType: "INPUT", placeholder: "+91 7973615772", required: false, defaultValue: "" },
    { fieldName: "cta1_href", label: "Phone Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "tel:+917973615772 (optional)", required: false, defaultValue: "" },
    { fieldName: "cta1_bg_color", label: "Phone Pill BG (Desktop)", value: "rgba(0,0,0,0.1)", valueType: "string", filedType: "COLOR", placeholder: "rgba(0,0,0,0.1)", required: false, defaultValue: "rgba(0,0,0,0.1)" },
    { fieldName: "cta1_text_color", label: "Phone Text / Icon Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "cta1_border_color", label: "Phone Circle Border (Mobile)", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- CTA-2 (WhatsApp) ---
    { fieldName: "cta2_enabled", label: "Show WhatsApp", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable WhatsApp", defaultValue: true },
    { fieldName: "cta2_icon", label: "WhatsApp Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload WhatsApp icon (optional)", required: false, defaultValue: "" },
    { fieldName: "cta2_icon_alt", label: "WhatsApp Icon Alt", value: "WhatsApp", valueType: "string", filedType: "INPUT", placeholder: "WhatsApp", required: false, defaultValue: "WhatsApp" },
    { fieldName: "cta2_href", label: "WhatsApp Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "https://wa.me/... or a number", required: false, defaultValue: "" },
    { fieldName: "cta2_bg_color", label: "WhatsApp BG Color", value: "#4CAF51", valueType: "string", filedType: "COLOR", placeholder: "#4CAF51", required: false, defaultValue: "#4CAF51" },
    { fieldName: "cta2_text_color", label: "WhatsApp Icon Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },

    // --- CTA-3 (Apply Now) — visibility is per-breakpoint ---
    { fieldName: "cta3_enabled", label: "Show Apply Now Button on Desktop", value: false, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show the Apply Now button on the desktop bar", defaultValue: false },
    { fieldName: "cta3_enabled_mobile", label: "Show Apply Now Button on Mobile", value: false, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show the Apply Now button on the mobile bar", defaultValue: false },
    { fieldName: "cta3_label", label: "Apply Now Label", value: "APPLY NOW", valueType: "string", filedType: "INPUT", placeholder: "APPLY NOW", required: false, defaultValue: "APPLY NOW" },
    { fieldName: "cta3_href", label: "Apply Now Link", value: "", valueType: "string", filedType: "INPUT", placeholder: "Leave empty to open the lead form popup", required: false, defaultValue: "" },
    { fieldName: "cta3_bg_color", label: "Apply Now BG Color", value: "#D61229", valueType: "string", filedType: "COLOR", placeholder: "#D61229", required: false, defaultValue: "#D61229" },
    { fieldName: "cta3_text_color", label: "Apply Now Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "#FFFFFF", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "cta3_icon", label: "Apply Now Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload icon (optional — falls back to the arrow glyph)", required: false, defaultValue: "" },
    { fieldName: "cta3_icon_alt", label: "Apply Now Icon Alt", value: "Apply Now", valueType: "string", filedType: "INPUT", placeholder: "Apply Now", required: false, defaultValue: "Apply Now" },

    // --- Mobile chrome ---
    { fieldName: "show_hamburger", label: "Show Hamburger Menu on Mobile", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)", defaultValue: true },
    { fieldName: "hamburger_icon", label: "Hamburger Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload hamburger icon (optional)", required: false, defaultValue: "" },
    { fieldName: "hamburger_icon_alt", label: "Hamburger Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Menu", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon", label: "Mobile Close Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload close icon (optional)", required: false, defaultValue: "" },
    { fieldName: "mobile_cancel_icon_alt", label: "Mobile Close Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Close", required: false, defaultValue: "" },

    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable widget", defaultValue: true },
  ],
};

export const MENU_ITEM_2000_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true,
    priority: 1,
    text_color: "#FFFFFF",
    icon: "",
    icon_alt: "",
  },

  MENU_FIELDS_CONFIG: [
    { fieldName: "title", label: "Title", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter menu title (e.g., ABOUT US)", required: true, defaultValue: "" },
    { fieldName: "parent_id", label: "Parent Menu", value: null, valueType: "string", filedType: "SELECT", placeholder: "Select parent menu", required: false, defaultValue: null, options: [] },
    { fieldName: "slug", label: "Slug", value: "", valueType: "string", filedType: "INPUT", placeholder: "Auto-generated from title", defaultValue: "" },
    { fieldName: "url", label: "URL", value: "", valueType: "string", filedType: "INPUT", placeholder: "/programmes", required: true, defaultValue: "" },
    { fieldName: "priority", label: "Priority", value: 1, valueType: "number", filedType: "INPUT", placeholder: "Enter display priority", required: true, defaultValue: 1 },
    { fieldName: "status", label: "Status", value: true, valueType: "boolean", filedType: "TOGGLE", placeholder: "Enable/Disable menu item", defaultValue: true },
    { fieldName: "text_color", label: "Text Color", value: "#FFFFFF", valueType: "string", filedType: "COLOR", placeholder: "Enter text color (e.g., #FFFFFF)", required: false, defaultValue: "#FFFFFF" },
    { fieldName: "icon", label: "Dropdown Item Icon", value: "", valueType: "string", filedType: "FILE", placeholder: "Upload item icon (optional)", required: false, defaultValue: "" },
    { fieldName: "icon_alt", label: "Dropdown Item Icon Alt", value: "", valueType: "string", filedType: "INPUT", placeholder: "Enter icon alt text", required: false, defaultValue: "" },
  ],

  TREE_CONFIG: {
    treeTitle: "Menu Structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    itemDisplayFields: {
      primary: "title",
      secondary: "slug",
      statusField: "status",
      statusInactiveLabel: "Inactive",
      childrenField: "children",
    },

    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority",
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status",
    },

    parentFieldName: "parent_id",
    parentTopLevelValue: "null",
    parentTopLevelLabel: "-- Top Level --",

    formLabels: {
      addNew: "➕ Add New Menu Item",
      edit: "✏️ Edit Menu Item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id",
    childItemsFieldName: "menuItems",
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
    // PRD: max 7 nav links — block adding past 7 (top-level). Sub-items are
    // unbounded; NavBar2000 also slices to 7 at render so an over-long menu
    // saved before this cap (or written straight through the API, which has no
    // count guard) still renders on-design.
    itemLimits: { max: 7 },
  },
};
